export var FilterMode;
(function (FilterMode) {
    FilterMode[FilterMode["Point"] = 0] = "Point";
    FilterMode[FilterMode["Bilinear"] = 1] = "Bilinear";
    FilterMode[FilterMode["Trilinear"] = 2] = "Trilinear";
})(FilterMode || (FilterMode = {}));
